import React from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useSelector } from "react-redux";
import styled from "styled-components/macro";

import { TemporaryBusinessWarnings } from "components/DeploymentSaleSummaries/TemporaryBusinessWarnings";
import { Row } from "components/Layout";
import WaitForSync from "components/LoadingSpinner/WaitForSync";
import { ScaleOperatorSaleSummaryCards } from "components/SaleSummaryCards";

import { ApiModel } from "constants/loading";

import { useHasSelectedMobileView } from "hooks/useScreenSize";

import { getSaleNameForSale } from "lib/sale";

import { currentSaleSelector, scaleOperatorSummarySelector } from "selectors";

const TitleWrapper = styled(Row)`
  margin: 0 ${({ theme }) => theme.space[3]}px;
  justify: around;
  align: center;
`;
TitleWrapper.displayName = "TitleWrapper";

const Title = styled.h1`
  flex-grow: 1;
  font-size: ${({ theme }) => theme.fontSizes.epsilon}px;
`;
Title.displayName = "Title";

const IconBtn = styled(FontAwesomeIcon)`
  color: ${({ theme }) => theme.colors.primary};
  cursor: pointer;
`;
IconBtn.displayName = "IconBtn";

const ScaleOperatorOverview = () => {
  const sale = useSelector(currentSaleSelector);
  const saleName = getSaleNameForSale(sale);
  const summary = useSelector(scaleOperatorSummarySelector);

  const isMobile = useHasSelectedMobileView();

  return (
    <WaitForSync
      requiredData={[ApiModel.CONSIGNMENTS, ApiModel.SALES, ApiModel.SALE_LOTS]}
    >
      <div>
        <TitleWrapper>
          <Title>{saleName}</Title>
        </TitleWrapper>
        <ScaleOperatorSaleSummaryCards summary={summary} isMobile={isMobile} />
        <TemporaryBusinessWarnings />
      </div>
    </WaitForSync>
  );
};

export default ScaleOperatorOverview;
